/* eslint-disable */
import React from 'react';
import { Box, Typography } from '@mui/material';
import { SxProps } from "@mui/system";
import { Theme } from "@mui/material/styles";

type TLogo = {
    sx?: SxProps<Theme>;
    isOpenSidebar: boolean;
}

const Logo = ({ sx, isOpenSidebar }: TLogo): any => {
    return (
        <>
            {/*{(!isOpenSidebar) && <Box component="img" src="/static/images/logo.png" sx={{width: 40, height: 40, ...sx}}/>}

            {(isOpenSidebar) && <Box component="img" src="/static/images/logo-full.png" sx={{height: 40, ...sx}}/>}*/}
            {
                (isOpenSidebar) &&
                // <Typography
                //     variant={"h3"}
                //     sx={{
                //         color: "white",
                //         ml: -1
                //     }}
                // >
                //     <span style={{color: "#EFBF3D"}}>f</span>acturan.do
                // </Typography>
                <img src={`/static/images/logo.svg`} width={'auto'} height={23} alt="" loading="lazy" />
            }

            {
                (!isOpenSidebar) &&
                <Typography
                    variant={"h3"}
                    sx={{
                        color: "#EFBF3D",
                        ml: 1.4
                    }}
                >
                    f
                </Typography>
            }
        </>
    );
}

export default Logo;
